import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { getAllDiscussions } from '../../../redux/Thunks/discussionsThunk';
import { getAllDebates } from '../../../redux/Thunks/debatesThunk';
import { searchedKeywords } from '../../../redux/Slices/sharedUseEffectSlice';


function DashKeywordsSearchBox() {

        const dispatch = useDispatch()
        const [keyword, setKeyword] = useState("")
        const tabToDisplay = localStorage.getItem("whatToDisplay")



        const keywordOnChange = (e) => {

            setKeyword(e.target.value)
            dispatch(searchedKeywords(e.target.value))

            if(tabToDisplay === "feed"){
                dispatch(getAllDiscussions({search : e.target.value}))
            }else if(tabToDisplay === "debates"){
                dispatch(getAllDebates({search : e.target.value}))
            }
        }



  return (
    <form>
    <div className="relative">
        <input
            className="h-[32px] text-[14px] w-[100%] pl-4 pr-10 bg-white rounded-[10px] border-[1px solid #6B846B]
            focus:ring-blue-50 focus:border-blue-50 block"
            type="text"
            name="locationSearchKey"
            value={keyword}
            onChange={keywordOnChange}
            id="locationSearchKey"
            placeholder={`You can filter your ${tabToDisplay} by keywords...`}
            required
        />
    </div>
</form>
  )
}

export default DashKeywordsSearchBox
